import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from './WebPages/Home';
import About from './WebPages/About';
import ActiveList from './WebPages/ActiveList';
// import Chart from './WebPages/Chart/Chart';
import { ToastContainer } from 'react-toastify';
import Login from './Login';
import Logout from './Logout';
import Protected from './Protected';
import FileUpload from './WebPages/FileUpload';
import FileUploadNew from './WebPages/FileUploadNew';
import UserAdd from './WebPages/UserAdd';
import ProgramList from './WebPages/ProgramList';
import ProgramDetail from './WebPages/ProgramDetail';
import ProgramDetailv1 from './WebPages/ProgramDetailv1';
import AreaList from './WebPages/AreaList';
import PracticeList from './WebPages/PracticeList';
import DoctorList from './WebPages/DoctorList';
import AreaAdd from './WebPages/AreaAdd';
import PracticeAdd from './WebPages/PracticeAdd';
import DoctorAdd from './WebPages/DoctorAdd';
import History from './WebPages/History';
import UserList from './WebPages/UserList';
import InclinicList from './WebPages/InclinicList';
import Profile from './WebPages/Profile';
import Communication from './WebPages/Communication';
import Communicationv1 from './WebPages/Communicationv1';
import VocList from './WebPages/VocList';
import HomeSuperAdmin from './WebPages/SuperadminOverview';
import PatientEdit from './WebPages/PatientEdit';
import Test from './WebPages/Test';
import SearchPatient from './WebPages/SearchPatient';
import ForgotPassword from './ForgotPassword';
import UploadSummary from './WebPages/UploadSummary';
import ImagesGalleryView from './WebPages/ImagesGalleryView';
import FileUploadText from './WebPages/FileUploadText';
import ProSession from './WebPages/ProSession/ProSession';
import SuperOverview from './WebPages/super-overview/Index';
import ReportPage from './WebPages/Report/Index';
import ReportDownloadPage from './WebPages/Report/PDFDownloadComponent';
import PendingActions from './WebPages/PendingActions';
import MyAppointments from './WebPages/MyAppointments/MyAppointments';
import WhatsappLogs from './WebPages/WhatsappLogs/WhatsappLogs';

const App = () => {


  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/logout" element={<Logout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<Login />} />
          {/* <Route path="/home" element={<Protected Component={ Home } />}/> */}
          <Route path="/about" element={<Protected Component={About} />} />
          <Route path="/active-list" element={<Protected Component={ActiveList} />} />
          <Route path="/upload" element={<Protected Component={FileUploadNew} />} />
          <Route path="/upload-new" element={<Protected Component={FileUpload} />} />
          <Route path="/user-add/:id?" element={<Protected Component={UserAdd} />} />
          {/* <Route path="/add-user" element={<Protected Component={ UserAdd } />}/> */}
          <Route path="/program-list" element={<Protected Component={ProgramList} />} />
          <Route path="/program-detail" element={<Protected Component={ProgramDetail} />} />
          {/* new table */}
          <Route path="/program-detail-v1" element={<Protected Component={ProgramDetailv1} />} />
          {/* new table */}
          <Route path="/history" element={<Protected Component={History} />} />
          <Route path="/user-list" element={<Protected Component={UserList} />} />
          <Route path="/area-list" element={<Protected Component={AreaList} />} />
          <Route path="/practice-list" element={<Protected Component={PracticeList} />} />
          <Route path="/doctor-list" element={<Protected Component={DoctorList} />} />
          <Route path="/area-add/:id?" element={<Protected Component={AreaAdd} />} />
          <Route path="/practice-add/:id?" element={<Protected Component={PracticeAdd} />} />
          <Route path="/doctor-add/:id?" element={<Protected Component={DoctorAdd} />} />
          <Route path="/patient-add/:id?" element={<Protected Component={PatientEdit} />} />
          <Route path="/inclinic-list" element={<Protected Component={InclinicList} />} />
          <Route path="/profile/:id?" element={<Protected Component={Profile} />} />
          <Route path="/communication" element={<Protected Component={Communication} />} />
          <Route path="/communication-v1" element={<Protected Component={Communicationv1} />} />
          <Route path="/voc" element={<Protected Component={VocList} />} />
          <Route path="/search" element={<Protected Component={SearchPatient} />} />
          <Route path="/upload-summary" element={<Protected Component={UploadSummary} />} />

          <Route path="/home" element={<Navigate to="/super-overview" />} />
          {/* <Route path="/super-overview" element={<Protected Component={ HomeSuperAdmin } />}/> */}

          <Route path="/super-overview-test" element={<Protected Component={HomeSuperAdmin} />} />
          <Route path="/super-overview" element={<Protected Component={SuperOverview} />} />
          <Route path="/reports" element={<Protected Component={ReportPage} />} />
          <Route path="/download" element={<Protected Component={ReportDownloadPage} />} />
          <Route path="/test" element={<Protected Component={FileUploadText} />} />
          <Route path="/session" element={<Protected Component={ProSession} />} />
          <Route path="/pro-session/create" element={<Protected Component={ProSession} />} />
          <Route path="/pro-session/edit/:id" element={<Protected Component={ProSession} />} />
          <Route path="/pro-session/:id" element={<Protected Component={ProSession} />} />
          <Route path="/pending-actions" element={<Protected Component={PendingActions} />} />

          <Route path="/my-appointments" element={<MyAppointments />} />

          <Route path="/whatsapp-logs" element={<WhatsappLogs />} />

        </Routes>
      </Router>
    </>
  );


}
export default App;   